// Thin wrappers around @sentry/react-router.
// Initialization is handled by app/entry.client.tsx (client) and
// instrument.server.mjs (server) — do not call init here.

import * as Sentry from "@sentry/react-router";

export function captureException(error: Error | unknown, context?: Record<string, unknown>) {
  Sentry.captureException(error, { extra: context });
}

export function captureMessage(
  message: string,
  level: "info" | "warning" | "error" | "debug" | "fatal" = "info",
  context?: Record<string, unknown>,
) {
  Sentry.captureMessage(message, { level, extra: context });
}

export function setUser(user: { id?: string; email?: string } | null) {
  Sentry.setUser(user ? { id: user.id } : null);
}

export function addBreadcrumb(
  message: string,
  category = "custom",
  data?: Record<string, unknown>,
) {
  Sentry.addBreadcrumb({ message, category, data, level: "info" });
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return children as any;
}

export function withSentryErrorBoundary<T extends object>(Component: React.ComponentType<T>) {
  return Component;
}

export default { captureException, captureMessage, setUser, addBreadcrumb, SentryErrorBoundary, withSentryErrorBoundary };
